// Card-level mini-PDP trigger for the Add Accessories carousel.
//
// Cards keep their real <a href> elements (image and title) so the product URL stays crawlable,
// focusable, and openable in a new tab; a plain left click is intercepted and forwarded to the
// card's own "+" button instead. That button already carries data-product-handle,
// data-product-count and the inline template[data-mini-pdp-content] that mini-pdp-drawer.js
// resolves from the click target, so this stays identical to pressing "+" rather than duplicating
// the drawer wiring here.

const CARD_SELECTOR = '.add-accessories product-card';
const MINI_PDP_BUTTON_SELECTOR = '.mini-pdp-add';
const INTERACTIVE_SELECTOR = 'button, input, label, select, [tabindex="1"]';

/**
 * @param {MouseEvent} event
 */
function handleCardClick(event) {
  if (event.defaultPrevented || event.button !== 0) return;
  if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

  const target = event.target instanceof Element ? event.target : null;
  if (!target || target.closest(INTERACTIVE_SELECTOR)) return;

  const button = target.closest(CARD_SELECTOR)?.querySelector(MINI_PDP_BUTTON_SELECTOR);
  if (!(button instanceof HTMLElement)) return;

  event.preventDefault();
  button.click();
}

document.addEventListener('click', handleCardClick, { capture: true });
